import React, { memo, ReactElement, Children, cloneElement } from 'react'
import {
  DraggableStateSnapshot,
  Draggable,
  DraggableProvided,
  Droppable,
  DroppableProvided,
} from 'react-beautiful-dnd'

export interface ITableBodyProps extends JSX.ElementChildrenAttribute {
  id?: string
  dataTest?: string
  isDraggable?: boolean
}

export const TableBody = memo<ITableBodyProps>(({ children, dataTest, isDraggable = false }) => {
  const validChildren = Array.isArray(children)
    ? (children as ReactElement[]).filter(Boolean)
    : (children as ReactElement)
  if (isDraggable) {
    return (
      <Droppable isDropDisabled={!isDraggable} droppableId='table'>
        {(droppableProvided: DroppableProvided) => (
          <tbody
            data-test={dataTest}
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}>
            {Children.map(validChildren, (child: ReactElement, idx: number) => (
              <Draggable
                index={idx}
                draggableId={`${child.key}`}
                // The entire table can be made not draggable, or an
                // individual row can be made not draggable.
                isDragDisabled={!isDraggable || !child.props.isDraggable}>
                {(draggableProvided: DraggableProvided, snapshot: DraggableStateSnapshot) =>
                  cloneElement(child, {
                    tableCellType: 'td',
                    isDragging: snapshot.isDragging,
                    draggableProvided,
                    isDraggable,
                  })
                }
              </Draggable>
            ))}
            {droppableProvided.placeholder}
          </tbody>
        )}
      </Droppable>
    )
  }
  return (
    <tbody data-test={dataTest}>
      {Children.map(validChildren, (child: ReactElement) =>
        cloneElement(child, { tableCellType: 'td' })
      )}
    </tbody>
  )
})
